import {
  UsersIcon,
  Squares2X2Icon,
  ClipboardDocumentListIcon,
  AcademicCapIcon,
  ClipboardDocumentCheckIcon,
  CogIcon,
  MagnifyingGlassIcon,
  DocumentTextIcon,
  SparklesIcon,
  BuildingOffice2Icon,
  CreditCardIcon,
  BuildingStorefrontIcon,
  ArrowUpTrayIcon,
  TagIcon,
  ListBulletIcon,
  CalendarDaysIcon,
} from '@heroicons/react/24/outline';

const baseNavigation = {
  Staffing: [
    {
      name: 'Dashboard',
      href: ['/dashboard'],
      icon: Squares2X2Icon,
      current: false,
      showForRoles: ['ahedge_cse', 'ahedge_ta'],
    },
    {
      name: 'Opportunities',
      href: ['/opportunities'],
      icon: SparklesIcon,
      current: false,
      showForRoles: ['ahedge_cse', 'ahedge_ta'],
    },
    {
      name: 'Search',
      href: ['/candidates/search'],
      icon: MagnifyingGlassIcon,
      current: false,
      showForRoles: ['ahedge_cse', 'ahedge_ta'],
    },
    {
      name: 'Job Postings',
      href: ['/job-postings', '/job-postings/create'],
      icon: ClipboardDocumentListIcon,
      current: false,
      showForRoles: ['ahedge_ta'],
    },
    {
      name: 'Skilling',
      href: ['#'],
      icon: AcademicCapIcon,
      current: false,
      comingSoon: true,
      showForRoles: ['ahedge_cse', 'ahedge_ta'],
    },
    {
      name: 'Certification',
      href: ['#'],
      icon: ClipboardDocumentCheckIcon,
      current: false,
      comingSoon: true,
      showForRoles: ['ahedge_cse', 'ahedge_ta'],
    },
    {
      name: 'Billing',
      href: ['/purchase-order'],
      icon: CreditCardIcon,
      current: false,
      showForRoles: ['ahedge_cse'],
    },
    {
      name: 'Interviews',
      href: ['/interviews/upcoming'],
      icon: CalendarDaysIcon,
      current: false,
      showForRoles: ['ahedge_interviewer'],
    },
  ],

  Settings: [
    {
      name: 'Job Personas',
      href: ['/personas'],
      icon: ClipboardDocumentListIcon,
      current: false,
      showForRoles: ['ahedge_admin'],
    },
    {
      name: 'Skill Resolution',
      href: ['/skill-resolution'],
      icon: TagIcon,
      current: false,
      showForRoles: ['ahedge_admin'],
    },
    {
      name: 'Test Management',
      href: ['/tests'],
      icon: DocumentTextIcon,
      current: false,
      showForRoles: ['ahedge_admin', 'ahedge_ta'],
    },
    {
      name: 'Organizations',
      href: ['/organizations'],
      icon: BuildingOffice2Icon,
      current: false,
      showForRoles: ['ahedge_admin'],
    },
    {
      name: 'Partners',
      href: ['/partners'],
      icon: BuildingOffice2Icon,
      current: false,
      showForRoles: ['ahedge_admin'],
    },
    {
      name: 'Application',
      href: ['/application-settings'],
      icon: CogIcon,
      current: false,
      showForRoles: ['ahedge_admin'],
    },
    {
      name: 'Assessment Types',
      href: ['/assessment-types'],
      icon: ListBulletIcon,
      current: false,
      showForRoles: ['ahedge_admin'],
    },
    {
      name: 'Upload Tracker',
      href: ['/upload-tracker'],
      icon: ArrowUpTrayIcon,
      current: false,
      showForRoles: ['ahedge_cse', 'ahedge_ta', 'ahedge_admin'],
    },
    {
      name: 'Vendors',
      href: ['/vendors'],
      icon: BuildingStorefrontIcon,
      current: false,
      showForRoles: ['ahedge_admin'],
    },
  ],

  UserManagement: [
    {
      name: 'Ahedge',
      href: ['/ahedge-users'],
      icon: UsersIcon,
      current: false,
      showForRoles: ['ahedge_admin'],
    },
    {
      name: 'Organizations',
      href: ['/organization-users'],
      icon: UsersIcon,
      current: false,
      showForRoles: ['ahedge_admin'],
    },
    {
      name: 'Partners',
      href: ['/partner-users'],
      icon: UsersIcon,
      current: false,
      showForRoles: ['ahedge_admin'],
    },
  ],
};
const filterNavigationByRole = (navSections, userRoles) => {
  // navSections is an object of { [sectionName]: MenuItem[] }
  const filtered = {};

  Object.entries(navSections).forEach(([sectionName, items]) => {
    const filteredItems = items
      .map((item) => {
        // Check if item should be shown based on roles
        if (
          item.showForRoles &&
          !item.showForRoles.some((role) => userRoles.includes(role))
        ) {
          return null;
        }

        if (item.subItems) {
          const filteredSubItems = item.subItems.filter(
            (subItem) =>
              !subItem.showForRoles ||
              subItem.showForRoles.some((role) => userRoles.includes(role))
          );

          if (filteredSubItems.length === 0) {
            return null;
          }

          return { ...item, subItems: filteredSubItems };
        }

        return item;
      })
      .filter(Boolean);

    // Always return the section key to keep consumer code simple.
    filtered[sectionName] = filteredItems;
  });

  return filtered;
};

export const getNavigation = (userRoles) =>
  filterNavigationByRole(baseNavigation, userRoles);

export const navigation = baseNavigation;
